module.exports = {
  redirectUri: "http://www.drybulkmatrix.com/oauth2/redirect",
  apiBaseUrl: "https://fleetsigma.com"
};
